//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const localizationStrings: any = {
  'en-us': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    hoverText: 'Shop Now',
    ecommerceProductDetailsCta: 'Shop',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
  },
  'fr-fr': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Afficher la galerie',
    galleryLinkUrl: '',
    hoverText: 'Acheter maintenant',
    ecommerceProductDetailsCta: 'Acheter',
    itemTrayTitle: 'Acheter ce style',
    loadMoreCtaText: 'Charger plus',
    uploaderCtaText: 'Télécharger le média',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Ajouter au panier',
    secondaryButtonText: 'Voir plus',
  },
  'it-it': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Guarda la galleria',
    galleryLinkUrl: '',
    hoverText: 'Compra ora',
    ecommerceProductDetailsCta: 'Compra',
    itemTrayTitle: 'Acquista questo look',
    loadMoreCtaText: 'Carica di più',
    uploaderCtaText: 'Aggiungi Altre Foto',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Aggiungi al carrello',
    secondaryButtonText: 'Vedi altro',
  },
  'de-de': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Galerie ansehen',
    galleryLinkUrl: '',
    hoverText: 'Jetzt einkaufen',
    ecommerceProductDetailsCta: 'Jetzt',
    itemTrayTitle: 'Diesen Look einkaufen',
    loadMoreCtaText: 'Mehr laden',
    uploaderCtaText: 'Mehr Inhalt hochladen',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'In den Warenkorb',
    secondaryButtonText: 'Mehr anzeigen',
  },
  'pl-pl': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Zobacz galerię',
    galleryLinkUrl: '',
    hoverText: 'Kupuj teraz',
    ecommerceProductDetailsCta: 'Kupuj',
    itemTrayTitle: 'kupuj ten look',
    loadMoreCtaText: 'Załaduj więcej',
    uploaderCtaText: 'Zaladuj Media',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Dodaj do koszyka',
    secondaryButtonText: 'Zobacz więcej',
  },
  'ru-ru': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Открыть галерею',
    galleryLinkUrl: '',
    hoverText: 'Купить',
    ecommerceProductDetailsCta: 'Купить',
    itemTrayTitle: 'Купить этот образ',
    loadMoreCtaText: 'Загрузить еще',
    uploaderCtaText: 'Загрузить медиафайл',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Добавить в корзину',
    secondaryButtonText: 'Показать ещё',
  },
  'es-es': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Ver galeria',
    galleryLinkUrl: '',
    hoverText: 'Compra ahora',
    ecommerceProductDetailsCta: 'Compra',
    itemTrayTitle: 'Compra este modelo',
    loadMoreCtaText: 'Cargar mas',
    uploaderCtaText: 'Descargar contenido',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Añadir al carrito',
    secondaryButtonText: 'Ver más',
  },
  'en-gb': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    hoverText: 'Shop Now',
    ecommerceProductDetailsCta: 'Shop',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
  },
  'en-ca': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    hoverText: 'Shop Now',
    ecommerceProductDetailsCta: 'Shop',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
  },
  'fr-ca': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Afficher la bibliothèque',
    galleryLinkUrl: '',
    hoverText: 'Acheter maintenant',
    ecommerceProductDetailsCta: 'Acheter',
    itemTrayTitle: 'Acheter cette tenue',
    loadMoreCtaText: 'Plus',
    uploaderCtaText: 'Téléverser un élément multimédia',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Ajouter au panier',
    secondaryButtonText: 'Voir plus',
  },
  'en-eu': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    hoverText: 'Shop Now',
    ecommerceProductDetailsCta: 'Shop',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
  },
  'pt-br': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Exibir galeria',
    galleryLinkUrl: '',
    hoverText: 'Comprar agora',
    ecommerceProductDetailsCta: 'Comprar',
    itemTrayTitle: 'Pesquisar baseado neste modelo',
    loadMoreCtaText: 'Carregar mais',
    uploaderCtaText: 'Enviar mídia',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Adicionar ao carrinho',
    secondaryButtonText: 'Ver mais',
  },
  'es-mx': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Ver galería',
    galleryLinkUrl: '',
    hoverText: 'Comprar ahora',
    ecommerceProductDetailsCta: 'Comprar',
    itemTrayTitle: 'Comprar este estilo',
    loadMoreCtaText: 'Cargar más',
    uploaderCtaText: 'Cargar elementos multimedia',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Añadir al carrito',
    secondaryButtonText: 'Ver más',
  },
  'es-us': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Ver Galería',
    galleryLinkUrl: '',
    hoverText: 'Comprar ahora',
    ecommerceProductDetailsCta: 'Comprar',
    itemTrayTitle: 'Comprar este estilo',
    loadMoreCtaText: 'Cargar más',
    uploaderCtaText: 'Cargar multimedia',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Añadir al carrito',
    secondaryButtonText: 'Ver más',
  },
  'sv-se': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Visa galleri',
    galleryLinkUrl: '',
    hoverText: 'Shoppa nu',
    ecommerceProductDetailsCta: 'Shoppa',
    itemTrayTitle: 'Shoppa den här looken',
    loadMoreCtaText: 'Läs in mer',
    uploaderCtaText: 'Ladda upp media',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Lägg i varukorg',
    secondaryButtonText: 'Visa mer',
  },
  'nl-nl': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Bekijke Gallerie',
    galleryLinkUrl: '',
    hoverText: 'Shop nu',
    ecommerceProductDetailsCta: 'Shop',
    itemTrayTitle: 'Shop deze look',
    loadMoreCtaText: 'Laad meer',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Toevoegen aan winkelwagen',
    secondaryButtonText: 'Bekijk meer',
  },
  'da-dk': {
    headerText: '',
    headerSubtext: '',
    galleryLinkCta: 'Se galleri',
    galleryLinkUrl: '',
    hoverText: 'Køb nu',
    ecommerceProductDetailsCta: 'Køb',
    itemTrayTitle: 'Køb dette look',
    loadMoreCtaText: 'Hent mere',
    uploaderCtaText: 'Upload medier',
    uploaderTermsAndConditionsLink: '',
    primaryButtonText: 'Læg i kurv',
    secondaryButtonText: 'Se mere',
  },
};
